import React from "react";
import { FaTimes } from "react-icons/fa";
import brandIcon from "assets/images/logo.png"; // Use your brand icon here

import { allAdConfigurations } from "../../../../../../helpers/adsConfigurations";

import ConnectedPlatformAccountMetaConfigurationModal from "./ConnectedPlatformAccountMetaConfigurationModal";

import ConnectedPlatformAccountGoogleConfigurationModal from "./ConnectedPlatformAccountGoogleConfigurationModal";
import ConnectedPlatformAccountTiktokConfigurationModal from "./ConnectedPlatformAccountTiktokConfigurationModal";
import ConnectedPlatformAccountSnapchatConfigurationModal from "./ConnectedPlatformAccountSnapchatConfigurationModal";
import ConnectedPlatformAccountLinkedInConfigurationModal from "./ConnectedPlatformAccountLinkedInConfigurationModal";
import ConnectedPlatformAccountShopifyOAuthConfigurationModal from "./ConnectedPlatformAccountShopifyOAuthConfigurationModal";

const ConnectedPlatformAccountConfigurationModal = ({
  platformName,
  headers,
  isOpen,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  if (!isOpen) return null;

  const renderComponent = () => {
    switch (platformName) {
      case allAdConfigurations.googleAdsConfiguration.slug:
        return (
          <ConnectedPlatformAccountGoogleConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );
      case allAdConfigurations.metaAdsConfiguration.slug:
        return (
          <ConnectedPlatformAccountMetaConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );
      case allAdConfigurations.tiktokAdsConfiguration.slug:
        return (
          <ConnectedPlatformAccountTiktokConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );
      case allAdConfigurations.snapchatAdsConfiguration.slug:
        return (
          <ConnectedPlatformAccountSnapchatConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );
      case allAdConfigurations.linkedinAdsConfiguration.slug:
        return (
          <ConnectedPlatformAccountLinkedInConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );

      case allAdConfigurations.shopifyOAuthAdsConfiguration.slug: // New case
        return (
          <ConnectedPlatformAccountShopifyOAuthConfigurationModal
            platformName={platformName}
            headers={headers}
            onClose={onClose}
            handleFetchConnectedPlatforms={() =>
              handleFetchConnectedPlatforms()
            }
          />
        );

      default:
        return (
          <div className="text-red-500 font-bold">
            Invalid platform selected
          </div>
        );
    }
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
          {/* Close Icon */}
          <button
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
            onClick={onClose}
          >
            <FaTimes size={20} />
          </button>

          {/* Brand Icon */}
          <div className="flex items-center gap-2 mb-4">
            <img
              src={brandIcon}
              alt={"Your Brand"}
              className="flex-grow-0"
              style={{ height: "20px" }}
            />
          </div>

          {/* Heading and Subheading */}
          <h2 className="text-lg font-bold text-gray-800 mb-2">
            Configure {platformName} Ads Manager
          </h2>
          {/* <p className="text-sm text-gray-600 mb-4">
            Please provide your API credentials.
          </p> */}

          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountConfigurationModal;
